'use client';

import { useEffect } from 'react';
import { useOptimizely, usePageLayout } from '@libs/common-next';
import { DigitalData } from '../DigitalData';
import { NoScriptIframe } from '../GtmPageViewTracker';
import { OneTrustScripts } from '../OneTrustScripts';

import { useCustomerKey } from './hooks';

export function TrackingScripts() {
    const { flags } = usePageLayout();
    const { customerKey } = useCustomerKey();
    const { init } = useOptimizely();

    useEffect(() => {
        init();
    }, [init]);

    // If performance mode is enabled, only render the GTM noscript iframe
    // and do not render the GTM script or any other tracking scripts
    if (flags.performanceModeGtmEnabled) {
        return <NoScriptIframe />;
    }

    return (
        <>
            <DigitalData />
            {flags.oneTrustEnabled && <OneTrustScripts data-testid="onetrust-script" customerKey={customerKey} />}
        </>
    );
}
